import React, { useState, useEffect, useMemo } from "react";
import { IEmployeeSupervisorProgression } from "../model/EmployeeSupervisorProgression.model";
import useFetchWithMsal from "../hooks/useFetchWithMsal";
import { protectedResources } from "../authConfig";
import { useMsal } from "@azure/msal-react";
import { Link } from "react-router-dom";
import { AllCommunityModule, ColDef, ModuleRegistry } from "ag-grid-community";
import { TreeDataModule } from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import CompetencyPeriodSelector from "../components/CompetencyPeriodSelector/CompetencyPeriodSelector";
import Loading from "../components/Loading/Loading";
import '../styles/pages/SupervisorEmpProgression.scss'

import { Icon } from "../components/icons/icons";

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule, TreeDataModule]);

const ButtonLinkComponent = (params: any) => {
  const { iconName, to, label = "View", tooltip=`View ${iconName}` } = params;
  const href = typeof to === "function" ? to(params.data) : to;
  const iconNameFull = `icon-${iconName}`;
 
  return (
    <div className='dis-flex dis-flex-rows dis-flex-aln-center gap--25 hgt-100'>
      <Link to={href} title={tooltip} tabIndex={0} className="btn-outlined-primary dis-flex dis-flex-rows dis-flex-aln-center gap--25" style={{ padding: '2px 8px', fontSize: '0.8rem', lineHeight: 1.2 }}>
        <Icon name={iconNameFull} width={14} height={14} />
        <span>{label}</span>
      </Link>
    </div>
  );
};
const SupervisorEmployeeProgression = () => {
  const { instance } = useMsal();
  const [account, setAccount] = useState(instance.getActiveAccount());
  const { error, execute } = useFetchWithMsal({
    scopes: protectedResources.apiCFSkillPath.scopes.read,
  });
  const [empList, setEmpList] = useState<IEmployeeSupervisorProgression[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedPeriodId, setSelectedPeriodId] = useState<string>('');

  const colDefs = useMemo<ColDef[]>(
    () => [

      { field: "CompetenciesCount", headerName: "Competencies" },
       {
        field: "",
        headerName: "View Competencies",
        headerTooltip: "View Competencies",
        headerAriaLabel: "View Competencies",
        cellRenderer: ButtonLinkComponent,
        cellRendererParams: {
          iconName: "bulb",
          to: (data: any) => `/competencies/${data.empUserPrincipalName}?periodId=${selectedPeriodId}`,
          label: "View",
          tooltip: "View Competencies"
        },
        cellClass: "right-border",
        headerClass: "right-border",        
        sortable: false,
        //resizable: false,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        suppressKeyboardEvent: (params: any) => params.event.key === 'Tab',
      },
      { field: "BookmarkCount", headerName: "Bookmarks" },
      { field: "MasteredCount", headerName: "Mastered" },
      { field: "MasteredConfirmedCount", headerName: "Confirmed Mastered" },
       {
        field: "",
        headerName: "View Skills",
        headerTooltip: "View Skill Inventory",
        headerAriaLabel: "View Skills",
        cellRenderer: ButtonLinkComponent,
        cellRendererParams: {
          iconName: "bookmark",
          to: (data: any) => "/bookmarks/" + data.empUserPrincipalName,
          label: "View",
          tooltip: "View Skills"
        },
        cellClass: "right-border",
        headerClass: "right-border",        
        sortable: false,
        //resizable: false,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        suppressKeyboardEvent: (params: any) => params.event.key === 'Tab',
      }
    ],
    [selectedPeriodId]
  );

  const defaultColDef = useMemo(
    () => ({
      minWidth: 120,      
      sortable: true,
      filter: false,
      wrapHeaderText: true,
      autoHeaderHeight: true     
    }),
    []
  );

  const autoGroupColumnDef = useMemo<ColDef>(
    () => ({
      headerName: "Employee Name",
      minWidth: 220,
      //maxWidth: 350,
      flex: 2,
      hide: true,
      filter: false,
      field: "fullName"
      //cellRenderer: 'path',
      // cellRendererParams: {
      //   suppressCount: true,
      //   innerRenderer: NameLinkComponent
      // },
    }),
    []
  );
  const getFullPath = (data:IEmployeeSupervisorProgression, currentList:string[]):string[] => {
    let supRecord = empList.find(d => d.employeeNumber===data.supervisorEmployeeNumber);
    if (!supRecord) { return currentList };
    currentList.push(supRecord.employeeNumber);
    return getFullPath(supRecord, currentList);
  }
  const getDataPath = (data: IEmployeeSupervisorProgression) => {
    console.log('getdatapath', data.fullName, data.SupervisorName, data.level, getFullPath(data, [data.employeeNumber]));
    return getFullPath(data, [data.employeeNumber]).reverse();
/*    return data.level === 2
      ? [data.fullName]
      : [data.SupervisorName, data.fullName];*/
  };

  useEffect(() => {
    if (!account || !selectedPeriodId) return;
    setLoading(true);
    execute("GET", `/api/SupEmpProgList/Heirarchical?periodId=${selectedPeriodId}`)
      .then((response) => {
        if (!response) {
          return;
        }
        if (response.error) {
          return;
        }
        setEmpList(response);
      })
      .catch((err: any) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, [account, selectedPeriodId, execute]);


  return (
    <>
      <div className="core-container desktop">
        <div className="core-desktop-max-width padded">
          <h2 className="fnt-wght-bold m-b-1 h1-size">My Team</h2>
           <CompetencyPeriodSelector onPeriodChange={(p) => setSelectedPeriodId(p.competencyMgmtPeriodId)} />
        </div>
        
      </div>
      <div><div className="m-l-10 fnt-sz-1">
          <div className="dis-flex dis-flx-aln-center gap--50">
            <Icon name="icon-info" className="icon-med-gray" style={{ width: 28, height: 28, flexShrink: 0 }} />
            <div>
              <p className="m-t-0 m-b-0"><span className="fnt-wght-bold">Competencies</span> – Assigned competencies in UKG</p>
              <p className="m-t-0 m-b-0"><span className="fnt-wght-bold">Bookmarks</span> – Skills to develop</p>
              <p className="m-t-0 m-b-0"><span className="fnt-wght-bold">Mastered</span> – Skills marked as proficient by the employee</p>
              <p className="m-t-0 m-b-0"><span className="fnt-wght-bold">Confirmed Mastered</span> – Mastery validated by the manager</p>
            </div>
          </div>
        </div><br /></div>
      <div className="sup-emp-prog-grid-container">
        <AgGridReact
          rowData={empList}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          autoGroupColumnDef={autoGroupColumnDef}
          treeData={true}
          getDataPath={getDataPath}
          domLayout="autoHeight"
          suppressRowVirtualisation={true}          
        />
      </div>
      <Loading isLoading={loading} />
    </>
  );
};

export default SupervisorEmployeeProgression;